import { useUserSession } from '@solinkcorp/authentication';
import { CallhomeApi } from 'clients';
import { type ScheduledActivityEntity } from 'clients/CallhomeApiTypes';
import useSWR from 'swr';

export default function useScheduledActivities() {
  const userSession = useUserSession();
  const scheduledActivities = useSWR('all-scheduled-activities', () => {
    return CallhomeApi(userSession.accessToken).listRecurringActivities();
  });

  const turnOffScheduledActivity = async (id: string) => {
    try {
      const updatedActivity = await CallhomeApi(userSession.accessToken).updateRecurringActivity(
        id,
        {
          reoccurringCount: 0,
        },
      );
      const newScheduledActivities = scheduledActivities.data?.map((activity) =>
        activity.id === id ? updatedActivity : activity,
      );
      scheduledActivities.mutate(newScheduledActivities);
      return updatedActivity;
    } catch {
      throw new Error('Failed to turn off scheduled activity');
    }
  };

  const createScheduledActivity = async (activity: Partial<ScheduledActivityEntity>) => {
    try {
      const newActivity = await CallhomeApi(userSession.accessToken).createRecurringActivity(
        activity,
      );

      const newScheduledActivities = [newActivity, ...(scheduledActivities.data ?? [])];
      scheduledActivities.mutate(newScheduledActivities);
      return newActivity;
    } catch (_error) {
      throw new Error('Failed to create scheduled activity');
    }
  };
  const updateScheduledActivity = async (
    id: string,
    activity: Partial<ScheduledActivityEntity>,
  ) => {
    try {
      const updatedActivity = await CallhomeApi(userSession.accessToken).updateRecurringActivity(
        id,
        activity,
      );
      const newScheduledActivities = scheduledActivities.data?.map((activity) =>
        activity.id === id ? updatedActivity : activity,
      );
      scheduledActivities.mutate(newScheduledActivities);
      return updatedActivity;
    } catch {
      throw new Error('Failed to create scheduled activity');
    }
  };

  return {
    ...scheduledActivities,
    turnOffScheduledActivity,
    createScheduledActivity,
    updateScheduledActivity,
  };
}
